import styled from "styled-components";

export const SectionCnpHolding = styled.section(({ theme }) => ({
  padding: "40px 16px",
  background: theme.color.neutral["07"],

  [theme.breakpoint.xl()]: {
    padding: "60px 112px",
  },
}));

export const TitleCnpHolding = styled.h2(({ theme }) => ({
  fontSize: "32px",
  fontWeight: 700,
  lineHeight: "150%",
  color: theme.color.brandPrimary.light,
  margin: 0,

  [theme.breakpoint.xl()]: {
    fontSize: "40px",
  },
}));

export const ContainerCardCnpHolding = styled.div(() => ({
  display: "flex",
  alignItems: "flex-start",
  gap: "45px",
  alignSelf: "stretch",
  marginTop: "32px",
}));

export const ContentCardCnpHolding = styled.div(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "32px",
  alignItems: "center",
}));

export const CardCnpHolding = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "space-between",
  flex: "1 0 0",
  padding: "32px",
  gap: "24px",
  borderRadius: "8px",
  border: `1px solid ${theme.color.line.medium}`,
  background: theme.color.neutral["08"],
  alignSelf: "stretch",
}));

export const ImgCardCnpHolding = styled.div(() => ({
  display: "flex",
  alignItems: "flex-end",
}));

export const ParagraphCardCnpHolding = styled.h2(({ theme }) => ({
  fontSize: "16px",
  fontWeight: 500,
  lineHeight: "150%",
  color: theme.color.neutral["02"],
  margin: 0,

  [theme.breakpoint.xl()]: {
    fontSize: "18px",
  },
}));

export const ButtonCardCnpHolding = styled.div(({ theme }) => ({
  display: "flex",
  padding: "16px 36px",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "8px",
  background: theme.color.brandSecondary.gradient,
  maxHeight: "51px",
  width: "100%",
  bottom: 0,
  cursor: "pointer",
}));

export const TextButtonCardCnpHolding = styled.p(({ theme }) => ({
  fontSize: "14px",
  fontWeight: 700,
  color: theme.color.neutral["08"],
  margin: 0,

  [theme.breakpoint.xl()]: {
    fontSize: "16px",
  },
}));
